module.exports = __webpack_public_path__ + "static/media/close_icon_white.3bc2faa5.png";